@if (pdfUrl) {
  <div class="video-container h-full w-full flex flex-col justify-center items-center bg-neutral-900 relative">
    <object
      [data]="pdfUrl"
      type="application/pdf"
      class="w-full h-full border-0"
    >
      <iframe
        [src]="pdfUrl"
        class="w-full h-full border-0"
      ></iframe>
    </object>
    @if (rawPdfUrl) {
      <div class="absolute bottom-3 right-3 z-10">
        <a
          [href]="rawPdfUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="daisy-btn daisy-btn-sm daisy-btn-primary gap-1.5 shadow-lg"
        >
          <i class="fa-solid fa-arrow-up-right-from-square text-xs"></i>
          <span>Open in New Tab</span>
        </a>
      </div>
    }
  </div>
}

@if (embedUrl) {
  <div class="video-container h-full w-full flex flex-col justify-center items-center">
    <iframe
      [src]="embedUrl"
      class="w-full h-full border-0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    ></iframe>
  </div>
}

@if (linkUrl) {
  <div class="video-container h-full w-full flex flex-col justify-center items-center bg-neutral-900 text-white p-6 sm:p-8 text-center">
    <div class="w-16 h-16 rounded-2xl bg-primary/20 text-primary flex items-center justify-center text-3xl mb-4 shadow-lg">
      <i class="fa-solid fa-arrow-up-right-from-square"></i>
    </div>
    <h3 class="text-xl sm:text-2xl font-bold mb-2">External Web Resource</h3>
    <p class="text-xs sm:text-sm text-neutral-400 max-w-md mb-6 break-all">
      {{ linkUrl }}
    </p>
    <a
      [href]="linkUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="daisy-btn daisy-btn-primary gap-2 shadow-lg"
    >
      <i class="fa-solid fa-arrow-up-right-from-square"></i>
      <span>Open Link in New Tab</span>
    </a>
  </div>
}

<div
  id="videoContainer"
  #videoContainer
  class="video-container h-full w-full flex flex-col justify-center items-center"
  [style.display]="embedUrl || pdfUrl || linkUrl ? 'none' : 'flex'"
>
  @if(isLoading && !embedUrl && !pdfUrl && !linkUrl) {
    <div class="loading-overlay" aria-live="polite">
      <div class="spinner" aria-hidden="true"></div>
      <p class="loading-text">Loading video…</p>
    </div>
  }

  <video
    class="video-player w-full h-full cursor-pointer"
    #videoPlayer
    id="videoPlayer"
    width="100%"
    height="100%"
    [attr.aria-busy]="isLoading"
  ></video>
</div>
